module.exports = __webpack_public_path__ + "img/MapaMundi (3).3dfe43e3.svg";